import React, {useMemo, useState} from "react";
import {TreeNode} from "../../../../types/Post";
import {CategoryTree} from "../CategoryTree";
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {Typography} from "../../../../designSystem/components/Typography";
import {CustomDialog} from "../../../../components/DialogCustom";

interface MoveCategoryDialogProps {
  categories: TreeNode[];
  initialCategory: TreeNode;
  onCancel: () => void;
  onMove: (category: { id: string; level: number; parentId: string }) => void;
}

export const MoveCategoryDialog = ({ categories, initialCategory, onCancel, onMove }: MoveCategoryDialogProps) => {
  const [selectedCategory, setSelectedCategory] = useState<TreeNode | null>(null);

  const currentName = useMemo(() => {
    return initialCategory ? initialCategory.name : ''
  }, [initialCategory])

  const submit = () => {
    onMove({
      id: initialCategory.id,
      level: selectedCategory.level + 1,
      parentId: selectedCategory.id,
    })
  }

  const canSubmit = !!selectedCategory && selectedCategory?.level < 3
  return (
    <CustomDialog>
      <div className="flex flex-col gap-4 text-left">
        <Typography variant="title">
          搬移分類
        </Typography>
        {currentName && (
          <Typography variant="bodyBold">
            要把 <span className="text-gray-700">{currentName}</span> 搬移至哪一個分類底下？
          </Typography>
        )}
        {categories?.length > 0 ? (
          <div className={"flex flex-1 overflow-y-scroll"}>
            <CategoryTree
              editMode={false}
              data={categories}
              selectedId={selectedCategory?.id ?? null}
              onSelect={(n) => setSelectedCategory(n)}
            />
          </div>
        ) : null}

        <div className="flex justify-end gap-2 mt-4">
          <ActionButton
            label="取消"
            onClick={onCancel}
            color="secondary"
          />
          <ActionButton
            label="搬移"
            iconName="fa-car-side"
            onClick={submit}
            disabled={!canSubmit}
          />
        </div>
      </div>
    </CustomDialog>
  );
};
